import { RootState } from '../store/configureStore';

export const getFields = (state: RootState) => state?.field?.fields;

export const isFetchingFields = (state: RootState) =>
  state?.field?.isFetchingFields

export const fetchingFieldsFailed = (state: RootState) =>
  state?.field?.fetchingFieldsFailed;
